<div>
  <h1>Masz niezapisane zmiany, co chcesz zrobić?</h1>
  <div class="actions">
    <lib-button (click)="close(1)">Zapisz i przejdź dalej</lib-button>
    <lib-button (click)="close(0)">Wróć do edycji</lib-button>
    <lib-button
      confirm
      (clicked)="close(-1)"
      color="warn"
      explainerMessage="Twoje zmiany zostaną utracone. Na pewno chcesz to zrobić?"
      >Odrzuć zmiany
    </lib-button>
  </div>
</div>
